export const POLL_INTERVAL_MS = 2000
export const POLL_DEADLINE_MS = 150000

export const executionsPath = (profilerId, hookId) => `/profilers/${profilerId}/hooks/${hookId}/executions`

export const executionPath = (profilerId, hookId, executionId) => `${executionsPath(profilerId, hookId)}/${executionId}`

const statusError = (status) => Object.assign(new Error(`execution failed (${status})`), { response: { status }, terminal: true })

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

export const pollButtonExecution = async ({ start, fetch, sleep = wait, now = Date.now }) => {
  const startedAt = now()
  const { executionId } = await start()

  while (true) {
    await sleep(POLL_INTERVAL_MS)

    try {
      const result = await fetch(executionId)
      if (result?.status === 'SUCCESS') return { display: result.display, executedAt: result.executedAt }
      if (result?.status === 'ERROR') throw statusError(result.errorStatus)
    } catch (err) {
      if (err.terminal || err.response?.status === 404) throw err
    }

    if (now() - startedAt >= POLL_DEADLINE_MS) throw statusError(504)
  }
}
